;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var View = APP.module('View');

	View.LeaguesList = Marionette.ItemView.extend({
		template: null,
		ui: {
			share_btn: '',
			countdown: '',
			load_more: '.js-load-more'
		},
		events: {
			'click @ui.share_btn':    'shareInvite',
			'complete @ui.countdown': 'completeCountdown',
			'click @ui.load_more': 'loadMore'
		},

		leagues_limit: 10,
		league_offset: 0,
		is_fetched_on_stop_countdown: false,

		initialize: function() {
			this.scrollToTop();
			this.share   = this.getOption('share');
			this.leagues = this.getOption('leagues');
			this.rounds  = this.getOption('rounds');
			this.user    = this.getOption('user');
			this.leagues_for_regeneration = this.getOption('leagues_for_regeneration');

			this.listenTo(this.leagues, 'leagues:errors', this.showErrors);

			var complete = [
				this.rounds.fetch({ cache: true, expires: 60 }),
				this.leagues.show_my().fetch()
			];

			if (this.leagues_for_regeneration) {
				complete.push(this.leagues_for_regeneration.show_for_regenerate().fetch())
			}

			this.setModelDefaults();

			$.when.apply(null, complete).done(_.bind(this.initTemplate, this));
		},

		setModelDefaults: function() {
			this.model.set({
				show_regeneration: false,
				leagues:           [],
				show_more:         false,
				round_actual: ''
			});
		},

		initTemplate: function() {
			if (this.initData().isNotEmptyLeagues()) {
				this.setModelData().render().initCountdown().hidePreloader();
			}
			return this;
		},

		initData: function() {

			this.leagues
				.setCommissioner(this.user.get('id'))
				.setLeaguesAvatars()
				.setStatus()
				.setDecimals(1);

			this.rounds.invoke('set', { 'selected': false });

			this.round_id = this.rounds.getNextScheduledRoundId();

			this.rounds.get(this.round_id).set({'selected': true});

			return this;
		},

		isNotEmptyLeagues: function() {

			if (!this.leagues.length && !this.leagues_for_regeneration.length) {
				this.trigger('leagues_list:empty');

				return false;
			}

			return true;
		},
		setModelData: function() {

			this.model.set({
				round_id:            this.round_id,
				leagues:             this.leagues.toJSON(),
				rounds:              this.rounds.toJSON(),
				user:                this.user.toJSON(),
				avatars_url:         CONFIG.AVATARS_URL,
				show_regeneration:   this.leagues_for_regeneration && this.leagues_for_regeneration.length > 0,
				regeneration_number: this.leagues_for_regeneration && this.leagues_for_regeneration.length,
				show_more:           this.isNeedLoadMore(),
				round_actual:        this.rounds.getLastPlayedRound().get('id')
			});

			return this;
		},

		isNeedLoadMore(){
			let size_leagues = this.leagues.length,
				delta_size = size_leagues-this.leagues_limit;

			if(delta_size < 0 && this.league_offset === 0){
				return false;
			}

			if(delta_size % this.league_offset){
				return false;
			}

			return this.league_offset ? size_leagues >= this.league_offset : size_leagues <= this.leagues_limit;
		},

		initCountdown: function() {

			this.ui.countdown.countdown();

			return this;
		},
		shareInvite: function(e) {

			var $el    = $(e.currentTarget),
				league = this.leagues.findWhere({ id: +$el.data('id') });

			this.share.invite({
				type:            $el.data('type'),
				team:            this.user.get('team_name'),
				team_id:         league.get('team_id'),
				league:          league.get('name'),
				is_commissioner: league.get('is_commissioner'),
				league_id:       $el.data('id'),
				user_id:         this.user.get('id'),
				code:            league.get('code')
			});

			return this;
		},

		completeCountdown: function() {
			this.showPreloader();

			if (!this.is_fetched_on_stop_countdown) {
				console.log(1);
				this.leagues.show_my().fetch().then(_.bind(function() {

					this.leagues.setCommissioner(this.user.get('id')).setStatus();

					return this.hidePreloader().setModelData().render().initCountdown();
				}, this));
				this.is_fetched_on_stop_countdown = true;
			}

		},

		loadMore() {
			this.league_offset += this.leagues_limit;

			let leagues = this.leagues.toJSON();

			this.leagues.show_my().fetch({data: {offset: this.league_offset}}).then(_.bind(function() {

				leagues = leagues.concat(this.leagues.toJSON());

				this.leagues.reset(leagues);
				this.leagues.setCommissioner(this.user.get('id')).setStatus();

				return this.hidePreloader().setModelData().render().initCountdown();
			}, this));
		}
	});

}(window, APP, Backbone, Marionette, $, _));
